import api from './api'

export const aiService = {
  query: (query: string) =>
    api.post('/ai/query', { query }),

  analyze: (type: string, params?: any) =>
    api.post('/ai/analyze', { type, params }),

  predict: (metric: string, days: number = 30) =>
    api.get('/ai/predict', { params: { metric, days } }),

  getInsights: () =>
    api.get('/ai/insights'),
}
